// @flow strict

import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    flex: 1;
    height: 100%;
    width: 100%;
`;

export const SearchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
`;

export const FilterRow = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
`;

export const TableContainer = styled.div`
    flex: 1;
    overflow-y: auto;
`;

export const RoleButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const UserCell = styled.div`
    display: flex;
    flex-direction: column;
`;

export const UserCellName = styled.span`
    font-weight: 500;
`;

export const UserCellEmail = styled.span`
    font-size: 12px;
    color: #666;
`;

export const RoleDescriptions = styled.div`
    background: #f5f7fa;
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 16px;
    font-size: 13px;
    line-height: 1.6;
`;

export const RoleDescriptionItem = styled.div`
    margin-bottom: 4px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const RoleName = styled.span`
    font-weight: 600;
`;
